import { ImageInfo } from "./../types";

const meta_data = {
  altText: "campus image",
  height: 800,
  width: 1200,
};

export const images: Record<string, ImageInfo> = {
  "ALB-UMT_Campus_2023-05_CSI_001": {
    url: "https://images.cdn.edx.org/attachment-25543ALB-UMT_Campus_2023-05_CSI_001.webp",
    ...meta_data,
  },
  "AU-IR_Campus_2019-08_EKinsolving_017": {
    url: "https://images.cdn.edx.org/attachment-25753AU-IR_Campus_2019-08_EKinsolving_017.webp",
    ...meta_data,
  },
  "AU-LAW_Campus_2016-07_CSI_002": {
    url: "https://images.cdn.edx.org/attachment-25542AU-LAW_Campus_2016-07_CSI_002.webp",
    ...meta_data,
  },
  "EC-MSL_Campus_2019-05_EKinsolving_029": {
    url: "https://images.cdn.edx.org/attachment-25534EC-MSL_Campus_2019-05_EKinsolving_029.webp",
    ...meta_data,
  },
  "FOR-LAW_Campus_2012-10_CShinn_002": {
    url: "https://images.cdn.edx.org/attachment-25752FOR-LAW_Campus_2012-10_CShinn_002.webp",
    ...meta_data,
  },
  "GU-MSN_Campus_2019-04_Flickr_5634335599": {
    url: "https://images.cdn.edx.org/attachment-25528GU-MSN_Campus_2019-04_Flickr_5634335599.webp",
    ...meta_data,
  },
  "HPU-UMT_Campus_2024-2_School Provided_A7307309_SM": {
    url: "https://images.cdn.edx.org/attachment-25525HPU-UMT_Campus_2024-2_School-Provided_A7307309_SM.webp",
    ...meta_data,
  },
  "HPU-UMT_Campus_2024-2_School Provided_IMG_0598": {
    url: "https://images.cdn.edx.org/attachment-25523HPU-UMT_Campus_2024-2_School-Provided_IMG_0598.webp",
    ...meta_data,
  },
  "HOW-MSW_Campus_2020-11_CSI_001_edit": {
    url: "https://images.cdn.edx.org/attachment-25529HOW-MSW_Campus_2020-11_CSI_001_edit.webp",
    ...meta_data,
  },
  "LU-UMT_Campus_2025-1_School Provided_SL_LancsUni_Jun22_SLV_2944_HR": {
    url: "https://images.cdn.edx.org/attachment-25521LU-UMT_Campus_2025-1_School-Provided_SL_LancsUni_Jun22_SLV_2944_HR.webp",
    ...meta_data,
  },
  "LSE-DIT_894314988": {
    url: "https://images.cdn.edx.org/attachment-25522LSE-DIT_894314988.webp",
    ...meta_data,
  },
  "MC-UG_Campus_2019-04_Raftermen_002": {
    url: "https://images.cdn.edx.org/attachment-25518MC-UG_Campus_2019-04_Raftermen_002.webp",
    ...meta_data,
  },
  "MGH-MHA_Campus_2024-8_School Provided_1317_25859441656_o": {
    url: "https://images.cdn.edx.org/attachment-25517MGH-MHA_Campus_2024-8_School-Provided_1317_25859441656_o.webp",
    ...meta_data,
  },
  "NYU-MSL_Campus_2019-06_EKinsolving_003": {
    url: "https://images.cdn.edx.org/attachment-25510NYU-MSL_Campus_2019-06_EKinsolving_003.webp",
    ...meta_data,
  },
  NU_KELLOG_02: {
    url: "https://images.cdn.edx.org/attachment-25514NU_KELLOG_02.webp",
    ...meta_data,
  },
  "PEP-PSY_6U2A9608_Kinsolving_Campus_7-2019": {
    url: "https://images.cdn.edx.org/attachment-25507PEP-PSY_6U2A9608_Kinsolving_Campus_7-2019.webp",
    ...meta_data,
  },
  "PEP-LAW_Campus_2015-10_CSI_002": {
    url: "https://images.cdn.edx.org/attachment-25754PEP-LAW_Campus_2015-10_CSI_002.webp",
    ...meta_data,
  },
  "PEP-MSLP_Campus_2024-9_School Provied_226084_DJI_0034a": {
    url: "https://images.cdn.edx.org/attachment-25509PEP-MSLP_Campus_2024-9_School-Provied_226084_DJI_0034a.webp",
    ...meta_data,
  },
  "RICE-MBA_Campus_2017-02_JFitlow_006": {
    url: "https://images.cdn.edx.org/attachment-25505RICE-MBA_Campus_2017-02_JFitlow_006.webp",
    ...meta_data,
  },
  "RIT-ARC_Campus_2020-08_CSI_003": {
    url: "https://images.cdn.edx.org/attachment-25503RIT-ARC_Campus_2020-08_CSI_003.webp",
    ...meta_data,
  },
  "RSC-MSOT_Campus_2023-09_THansen_001": {
    url: "https://images.cdn.edx.org/attachment-25501RSC-MSOT_Campus_2023-09_THansen_001.webp",
    ...meta_data,
  },
  "SC-MSN_Campus_2013-01_JGillooly_0019-EDIT": {
    url: "https://images.cdn.edx.org/attachment-25497SC-MSN_Campus_2013-01_JGillooly_0019-EDIT.webp",
    ...meta_data,
  },
  "070817CC128": {
    url: "https://images.cdn.edx.org/attachment-25545070817CC128.webp",
    ...meta_data,
  },
  "SC-ENT_6U2A3005_Kinsolving_Campus_7-2019": {
    url: "https://images.cdn.edx.org/attachment-25498SC-ENT_6U2A3005_Kinsolving_Campus_7-2019.webp",
    ...meta_data,
  },
  "SJF-MSN_06_CSI_Nursing-Building_10-2020": {
    url: "https://images.cdn.edx.org/attachment-25494SJF-MSN_06_CSI_Nursing-Building_10-2020.webp",
    ...meta_data,
  },
  "SMU-MDS_Campus_2006-08_CSI_001": {
    url: "https://images.cdn.edx.org/attachment-25492SMU-MDS_Campus_2006-08_CSI_001.webp",
    ...meta_data,
  },
  "SYR-UMT_001_CSI_Campus_2021-08.": {
    url: "https://images.cdn.edx.org/attachment-25485SYR-UMT_001_CSI_Campus_2021-08.webp",
    ...meta_data,
  },
  "SYD-UMT_Campus_2017-01_LCooper_019": {
    url: "https://images.cdn.edx.org/attachment-25488SYD-UMT_Campus_2017-01_LCooper_019.webp",
    ...meta_data,
  },
  "UTA-UMT_Campus_2017-11_CSI_001": {
    url: "https://images.cdn.edx.org/attachment-25471UTA-UMT_Campus_2017-11_CSI_001.webp",
    ...meta_data,
  },
  "UWM-MSB_Campus_Grainger Hall_Exterior_2023-1_School Provided_0714_043": {
    url: "https://images.cdn.edx.org/attachment-25472UWM-MSB_Campus_Grainger-Hall_Exterior_2023-1_School-Provided_0714_043.webp",
    ...meta_data,
  },
  "UCD-MM_Campus_welcome-center_2023-8_School Provided_20130808-158": {
    url: "https://images.cdn.edx.org/attachment-25483UCD-MM_Campus_welcome-center_2023-8_School-Provided_20130808-158.webp",
    ...meta_data,
  },
  "MIA-MBA_Campus_2022-7_School Provided_Drone 0142": {
    url: "https://images.cdn.edx.org/attachment-25515MIA-MBA_Campus_2022-7_School-Provided_Drone-0142.webp",
    ...meta_data,
  },
  UNC_KF_04: {
    url: "https://images.cdn.edx.org/attachment-25477UNC_KF_04.webp",
    ...meta_data,
  },
  DAY_02: {
    url: "https://images.cdn.edx.org/attachment-25537DAY_02.webp",
    ...meta_data,
  },
  "DEN-MSW_Campus_2011-10_WArmstrong_001": {
    url: "https://images.cdn.edx.org/attachment-25536DEN-MSW_Campus_2011-10_WArmstrong_001.webp",
    ...meta_data,
  },
  "UL-BDS_Campus_CSI_2021-10_025": {
    url: "https://images.cdn.edx.org/attachment-25479UL-BDS_Campus_CSI_2021-10_025.webp",
    ...meta_data,
  },
  "ALB-UMT_Immersion_2023-08_CSI_002": {
    url: "https://images.cdn.edx.org/attachment-25541ALB-UMT_Immersion_2023-08_CSI_002.webp",
    ...meta_data,
  },
  "AU-MIR_175138289_GettyImages": {
    url: "https://images.cdn.edx.org/attachment-25539AU-MIR_175138289_GettyImages.webp",
    ...meta_data,
  },
  "AU-LAW_Campus_2019-09_EKinsolving_006": {
    url: "https://images.cdn.edx.org/attachment-25540AU-LAW_Campus_2019-09_EKinsolving_006.webp",
    ...meta_data,
  },
  "EC-MSL_People-With-Technology_2017-11_DPalmer_009": {
    url: "https://images.cdn.edx.org/attachment-25533EC-MSL_People-With-Technology_2017-11_DPalmer_009.webp",
    ...meta_data,
  },
  "FOR-MSW_Campus_2016-04_CSI_022": {
    url: "https://images.cdn.edx.org/attachment-25531FOR-MSW_Campus_2016-04_CSI_022.webp",
    ...meta_data,
  },
  "GU-MSN_Campus_2011-07_Flickr_5937268210": {
    url: "https://images.cdn.edx.org/attachment-25530GU-MSN_Campus_2011-07_Flickr_5937268210.webp",
    ...meta_data,
  },
  "HOW-MSW_Zoom_StudentGrid-12_OTS-Laptop": {
    url: "https://images.cdn.edx.org/attachment-25527HOW-MSW_Zoom_StudentGrid-12_OTS-Laptop.webp",
    ...meta_data,
  },
  "LU-UMT_People with Tech_2025-1_School Provided_2624_0618": {
    url: "https://images.cdn.edx.org/attachment-25520LU-UMT_People-with-Tech_2025-1_School-Provided_2624_0618.webp",
    ...meta_data,
  },
  LSE_05: {
    url: "https://images.cdn.edx.org/attachment-25524LSE_05.webp",
    ...meta_data,
  },
  "MC-UG_Zoom_StudentGrid-12_Mockup-OTS-Desktop": {
    url: "https://images.cdn.edx.org/attachment-25519MC-UG_Zoom_StudentGrid-12_Mockup-OTS-Desktop.webp",
    ...meta_data,
  },
  "MGH-MHA_Student_2024-8_School Provided_20220620-1069": {
    url: "https://images.cdn.edx.org/attachment-25516MGH-MHA_Student_2024-8_School-Provided_20220620-1069.webp",
    ...meta_data,
  },
  "NYU-MAC_Zoom_Mockup-OTS_StudentGrid-12": {
    url: "https://images.cdn.edx.org/attachment-25511NYU-MAC_Zoom_Mockup-OTS_StudentGrid-12.webp",
    ...meta_data,
  },
  "NU-MAC_Zoom_StudentGrid-12_Mockup-OTS-V1": {
    url: "https://images.cdn.edx.org/attachment-25512NU-MAC_Zoom_StudentGrid-12_Mockup-OTS-V1.webp",
    ...meta_data,
  },
  "PEP-PSY_MKTGAD-5949_Zoom_LaptopMockup": {
    url: "https://images.cdn.edx.org/attachment-25506PEP-PSY_MKTGAD-5949_Zoom_LaptopMockup.webp",
    ...meta_data,
  },
  "RICE-MBA_People-with-Technology_2020-03_ATao_008": {
    url: "https://images.cdn.edx.org/attachment-25504RICE-MBA_People-with-Technology_2020-03_ATao_008.webp",
    ...meta_data,
  },
  "RIT-ARC_People-with-Technology_2019-08_AdobeStock_294392902": {
    url: "https://images.cdn.edx.org/attachment-25502RIT-ARC_People-with-Technology_2019-08_AdobeStock_294392902.webp",
    ...meta_data,
  },
  "RSC-MSOT_People on the Job_2024-5_GettyImages_2094339326": {
    url: "https://images.cdn.edx.org/attachment-25500RSC-MSOT_People-on-the-Job_2024-5_GettyImages_2094339326.webp",
    ...meta_data,
  },
  "SC-MSN_People-with-Technology_2014-03_JDavis_1013": {
    url: "https://images.cdn.edx.org/attachment-25495SC-MSN_People-with-Technology_2014-03_JDavis_1013.webp",
    ...meta_data,
  },
  "SC-MSW_008_PeopleTechnology_2015": {
    url: "https://images.cdn.edx.org/attachment-25496SC-MSW_008_PeopleTechnology_2015.webp",
    ...meta_data,
  },
  "SC-ABA_Zoom_9-Class_Over-the-Shoulder_12-2018": {
    url: "https://images.cdn.edx.org/attachment-25499SC-ABA_Zoom_9-Class_Over-the-Shoulder_12-2018.webp",
    ...meta_data,
  },
  "SJF-MSN_Zoom_OTS-V2_StudentGrid-25": {
    url: "https://images.cdn.edx.org/attachment-25493SJF-MSN_Zoom_OTS-V2_StudentGrid-25.webp",
    ...meta_data,
  },
  "SMU-MDS_People-with-Technology_2014-02_YArcurs_001": {
    url: "https://images.cdn.edx.org/attachment-25491SMU-MDS_People-with-Technology_2014-02_YArcurs_001.webp",
    ...meta_data,
  },
  "SYR-MSW_Zoom_OverTheShoulder_StudentGrid12": {
    url: "https://images.cdn.edx.org/attachment-25486SYR-MSW_Zoom_OverTheShoulder_StudentGrid12.webp",
    ...meta_data,
  },
  "SYD-UMT_People on the Job_2023-7_GettyImages_1440556661": {
    url: "https://images.cdn.edx.org/attachment-25487SYD-UMT_People-on-the-Job_2023-7_GettyImages_1440556661.webp",
    ...meta_data,
  },
  "UTA-MAI-BC_People on the Job_2024-5_GettyImages_1415142004": {
    url: "https://images.cdn.edx.org/attachment-25473UTA-MAI-BC_People-on-the-Job_2024-5_GettyImages_1415142004.webp",
    ...meta_data,
  },
  "UCD-MM_Students_2023-8_Zoom_Mockup_v2": {
    url: "https://images.cdn.edx.org/attachment-25482UCD-MM_Students_2023-8_Zoom_Mockup_v2.webp",
    ...meta_data,
  },
  "MIA-MBA_People-with-Technology_2020-02_CLawrie_001": {
    url: "https://images.cdn.edx.org/attachment-25513MIA-MBA_People-with-Technology_2020-02_CLawrie_001.webp",
    ...meta_data,
  },
  "UNC-MPH_887_Kinsolving_Group_7-2019": {
    url: "https://images.cdn.edx.org/attachment-25476UNC-MPH_887_Kinsolving_Group_7-2019.webp",
    ...meta_data,
  },
  "UNC-UMT_People-with-Technology_2023-10_Getty_1271562709": {
    url: "https://images.cdn.edx.org/attachment-25474UNC-UMT_People-with-Technology_2023-10_Getty_1271562709.webp",
    ...meta_data,
  },
  "UD-EDU_On the Job_2022-3_GettyImages_1034426836": {
    url: "https://images.cdn.edx.org/attachment-25481UD-EDU_On-the-Job_2022-3_GettyImages_1034426836.webp",
    ...meta_data,
  },
  "UD-EDU_People-with-Technology_2018-01_Getty_1248900587.jpg": {
    url: "https://images.cdn.edx.org/attachment-25480UD-EDU_People-with-Technology_2018-01_Getty_1248900587.webp",
    ...meta_data,
  },
  "UL-BDS_People-with-Technology_2019-03_Getty_1186931714": {
    url: "https://images.cdn.edx.org/attachment-25478UL-BDS_People-with-Technology_2019-03_Getty_1186931714.webp",
    ...meta_data,
  },
};
